import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminCustomers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);
  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold tracking-tight mb-6">Müşteriler</h1>
      <div className="bg-white rounded-2xl border border-slate-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr className="text-left">
            <th className="p-3">Ad</th><th>E-posta</th><th>Telefon</th><th>Rol</th><th>Kayıt</th>
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t">
                <td className="p-3 font-semibold">{u.name}</td>
                <td>{u.email}</td>
                <td>{u.phone || "-"}</td>
                <td><span className={`text-xs px-2 py-0.5 rounded-full ${u.role === "admin" ? "bg-amber-100 text-amber-700" : "bg-slate-100"}`}>{u.role}</span></td>
                <td>{new Date(u.created_at).toLocaleDateString("tr-TR")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
